'use client'

import React, { useRef } from 'react'

import { PriceFilter } from '@/features/catalog/price-filter'

import { FilterDisplayType, FilterJsonType } from '@/entities/catalog-old'

import { Button } from '@/shared/ui'

import { useFilter } from '../hooks/useFilter'
import { getFilterUrlFromForm } from '../lib/get-filter-url-from-form'

import { AccordionFilter } from './accordion-filter/accordion-filter'
import { SwitchFilter } from './switch-filter/switch-filter'

import cls from './filter.module.scss'

type FilterProps = {
	sectionKey?: string
}

export const Filter = ({ sectionKey = 'mobile' }: FilterProps): JSX.Element => {
	const formRef = useRef<HTMLFormElement>(null)

	const { properties, isLoading, onFilterChange, clearFilter, appliedFiltersCount, serverPriceFilter } = useFilter()

	const submitFilter = (): void => {
		const filterUrl = getFilterUrlFromForm(formRef.current)

		if (serverPriceFilter) {
			const json = JSON.parse(filterUrl)
			json['PRICE'] = serverPriceFilter
			onFilterChange?.(JSON.stringify(json))
			return
		}

		onFilterChange?.(filterUrl)
	}

	const submitPriceFilter = (from: string, to: string): void => {
		const filterUrl = getFilterUrlFromForm(formRef.current)
		const json = JSON.parse(filterUrl)
		json['PRICE'] = { type: FilterJsonType.Price, value: [from, to] }
		onFilterChange?.(JSON.stringify(json))
	}

	const onChangeHandler = (): void => {
		submitFilter()
	}

	return (
		<article className={cls.root}>
			<form ref={formRef} onChange={onChangeHandler} onSubmit={() => false}>
				{properties?.map(({ CODE, DISPLAY_TYPE, DISPLAY_EXPANDED, NAME, VALUES }) => (
					<React.Fragment key={`${CODE}-${sectionKey}`}>
						{DISPLAY_TYPE === FilterDisplayType.RangeWithSlider && VALUES?.length === 2 && (
							<PriceFilter
								minValue={String(VALUES[0]?.VALUE ?? '')}
								maxValue={String(VALUES[1]?.VALUE ?? '')}
								checkedFrom={
									VALUES[0]?.CHECKED && VALUES[0]?.FILTERED_VALUE != null ? String(VALUES[0].FILTERED_VALUE) : undefined
								}
								checkedTo={
									VALUES[1]?.CHECKED && VALUES[1]?.FILTERED_VALUE != null ? String(VALUES[1].FILTERED_VALUE) : undefined
								}
								isDisabled={isLoading}
								onSubmit={submitPriceFilter}
							/>
						)}
						{DISPLAY_TYPE === FilterDisplayType.CheckBox && VALUES?.length > 0 && (
							<AccordionFilter
								defaultOpen={!!DISPLAY_EXPANDED}
								name={NAME}
								code={CODE}
								items={VALUES}
								isDisabled={isLoading}
							/>
						)}
						{DISPLAY_TYPE === FilterDisplayType.Radio && (
							<SwitchFilter
								label={NAME}
								name={CODE}
								checked={VALUES.some(value => value.CHECKED)}
								isDisabled={!VALUES[0].ELEMENT_COUNT || isLoading}
							/>
						)}
					</React.Fragment>
				))}
			</form>
			{!!appliedFiltersCount && (
				<Button onClick={clearFilter} theme="outlined" className={cls.clearButton}>
					Очистить фильтр
				</Button>
			)}
		</article>
	)
}
